import React from 'react';
import { useQueryClient } from 'react-query';
import {Select, MenuItem, InputLabel} from '@material-ui/core';
import { useCurrencies } from "../../../services/currencies";
import _ from "underscore";

const CurrencySelector = props => {

  const queryClient = useQueryClient();
  const extraKeys = [];
  const records = useCurrencies({queryClient, useCache: true, extraKeys});
  const style = props.style || {};
  const id = props.id;
  const label = props.label;
  const readOnly = props.readOnly || false;
  const fullWidth = props.fullWidth || false;

  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }
  const className = classNames.join(" ");

  const handleChange = event => {
    if (props.returnType === "object") {
      const returnObject = { value: event.target.value, found: false, data: {}}
      const data = _.findWhere(records.data, { currencyCode: event.target.value });
      if (data) {
        returnObject.found = true;
        returnObject.data = data;
      }
      props.onChange(returnObject);
    } else {
      props.onChange(event.target.value);
    }
  }

  return (
    <div>
      {label?
        <InputLabel shrink id={`${id}-label`} style={{marginLeft: 10, marginTop: 5, ...style}}>{label}</InputLabel>
        :<></>
      }
      <Select
        style={{...style}}
        readOnly={readOnly}
        className={className}
        value={props.value == null?'':props.value}
        fullWidth={fullWidth}
        onChange={handleChange}
        renderValue={(value) => `${value}`}
      >
        {(records.data) ?
          records.data.filter(currency => !currency.childCurrency).map((record) => {
            return (
              <MenuItem key={record.currencyCode} value={record.currencyCode}>{record.currencyCode} - {record.currencyName}</MenuItem>
            );
          }) :
          null
        }
      </Select>
    </div>
  )
}

export default CurrencySelector;
